import { render, staticRenderFns } from "./activity_home.vue?vue&type=template&id=a5291bc6&scoped=true"
import script from "./activity_home.vue?vue&type=script&lang=js"
export * from "./activity_home.vue?vue&type=script&lang=js"
import style0 from "./activity_home.vue?vue&type=style&index=0&id=a5291bc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5291bc6",
  null
  
)

export default component.exports